'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _analytics = require('../../redux/modules/analytics');

var _redux = require('redux');

var _react = require('react');

var _reactRedux = require('react-redux');

var _reactFastCompare = require('react-fast-compare');

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    return {
        attributionData: (0, _analytics.getAttributionData)(state)
    };
};


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        recordAttributionAnalytics: _analytics.recordAttributionAnalytics
    }, dispatch);
};

var SegmentTracker = function (_Component) {
    (0, _inherits3.default)(SegmentTracker, _Component);

    function SegmentTracker() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SegmentTracker);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SegmentTracker.__proto__ || (0, _getPrototypeOf2.default)(SegmentTracker)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = function (nextProps) {
            return !(0, _reactFastCompare2.default)(_this.props, nextProps);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SegmentTracker, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.recordAttributionAnalytics(this.props.attributionData);
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return SegmentTracker;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SegmentTracker);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Segment/SegmentTracker.js
// module id = 6f2F
// module chunks = 60